var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-page" },
    [
      _c("tab-warehouse", {
        ref: "tabWarehouse",
        attrs: {
          context: _vm.context,
          action: _vm.action,
          "cooperate-edit": _vm.cooperateEditWarehouse
        }
      }),
      _vm.job.landTransportation
        ? _c("tab-trucking", {
            ref: "tabTrucking",
            attrs: {
              context: _vm.context,
              action: _vm.action,
              "cooperate-edit": _vm.cooperateEditTrucking
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }